/** Tabela kao tekst razdvojen tabulatorima: lepi se u Excel, Google Sheets i poruke. */
export const rowsToTsv = (headers, rows) =>
  [headers, ...rows]
    .map((row) => row.map((cell) => String(cell ?? "").replace(/[\t\r\n]+/g, " ")).join("\t"))
    .join("\n");

/**
 * Kopira tekst u clipboard (Clipboard API, sa rezervom za starije pregledače i http).
 * @param {string} text
 * @returns {Promise<boolean>} true ako je kopirano
 */
export const copyText = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    // pada na rezervu ispod
  }
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.appendChild(area);
  area.select();
  let copied = false;
  try {
    copied = document.execCommand("copy");
  } catch (error) {
    copied = false;
  }
  document.body.removeChild(area);
  return copied;
};
